<div>
  <p-fieldset>
    <form [formGroup]="changeprimaryinstitutionform">
      <div class="d-flex justify-content-between">
        <div class="form-group">
          <label>Medlem</label>
          <div>{{memberid}} {{givenname}} {{familyname}}</div>
        </div>
        <div class="form-group">
          <label>Från institution</label>
          <div>{{primaryinstitution?.shortName}} {{primaryinstitution?.name}}</div>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="toInstitutionId">Till institution</label>
          <select class="form-control form-control-sm" id="toInstitutionId" formControlName="toInstitutionId" required>
            <option></option>
            <option *ngFor="let i of institutions" [ngValue]="i.id">{{i.shortName}} {{i.name}}</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label for="fromDate">Från datum</label>
          <app-calendar [form]="changeprimaryinstitutionform" formName="fromDate" [required]=true></app-calendar>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-4">
          <label for="causeId">Anledning</label>
          <select class="form-control form-control-sm" id="causeId" formControlName="causeId" required>
            <option></option>
            <option *ngFor="let ec of exitcauses" [ngValue]="ec.id">{{ec.description}}</option>
          </select>
        </div>
      </div>
    </form>
    <br>
    <div class="d-flex justify-content-start">
      <div class="d-flex justify-content-between gap-1">
        <div>
          <button class="btn border" (click)="confirmDialog()" [disabled]="!changeprimaryinstitutionform.valid">Spara</button>
        </div>
        <div style="margin-left:20px;">
          <button class="btn border" (click)="close()">Avbryt</button>
        </div>
        </div>
     </div>
  </p-fieldset>
</div>